import { useContext, useEffect, useLayoutEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';

import PrimeReact, { addLocale } from 'primereact/api';
import { Toast } from 'primereact/toast';
import { classNames } from 'primereact/utils';
import PropTypes from 'prop-types';

import AppSidebar from './AppSidebar';
// eslint-disable-next-line import/no-cycle
import AppTopbar from './AppTopbar';
import { LayoutContext } from './context/layoutcontext';
// eslint-disable-next-line import/no-mutable-exports
export let toast;

const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

function Layout({ children, style }) {
  const { t } = useTranslation();
  const toastRef = useRef(null);
  const { layoutConfig, layoutState, setLayoutState } = useContext(LayoutContext);
  const topbarRef = useRef(null);
  const sidebarRef = useRef(null);

  PrimeReact.ripple = true;

  const containerClass = classNames('layout-wrapper', {
    'layout-theme-light': layoutConfig.colorScheme === 'light',
    'layout-theme-dark': layoutConfig.colorScheme === 'dark',
    'layout-overlay': layoutConfig.menuMode === 'overlay',
    'layout-static': layoutConfig.menuMode === 'static',
    'layout-static-inactive':
      layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
    'layout-overlay-active': layoutState.overlayMenuActive,
    'layout-mobile-active': layoutState.staticMenuMobileActive,
    'p-input-filled': layoutConfig.inputStyle === 'filled',
    'p-ripple-disabled': !layoutConfig.ripple,
  });

  useEffect(() => {
    document.title = t('websiteName');
  }, [t]);

  useLayoutEffect(() => {
    toast = (mode, detail) =>
      toastRef.current.show({
        severity: mode,
        summary: t(`toast.${mode}`),
        detail,
        life: 4000,
      });
  });

  addLocale('vi', {
    firstDayOfWeek: 1,
    dayNames: dayNames.map((dayName) => t(`formControl.dateLocale.dayNames.${dayName}`)),
    dayNamesShort: dayNames.map((dayName) =>
      t(`formControl.dateLocale.dayNamesShort.${dayName.slice(0, 3)}`)
    ),
    dayNamesMin: dayNames.map((dayName) =>
      t(`formControl.dateLocale.dayNamesShort.${dayName.slice(0, 3)}`)
    ),
    monthNames: Array(12)
      .fill(null)
      .map((e, i) => `${t('formControl.dateLocale.month')} ${i + 1}`),
    monthNamesShort: Array(12)
      .fill(null)
      .map((e, i) => `${t('formControl.dateLocale.monthShort')} ${i + 1}`),
    today: t('formControl.dateLocale.today'),
    clear: t('formControl.dateLocale.clear'),
  });
  return (
    <div className={containerClass}>
      <AppTopbar ref={topbarRef} />
      <div ref={sidebarRef} className="layout-sidebar-cyan layout-sidebar">
        <AppSidebar />
      </div>
      <div className="layout-main-container">
        <div className="layout-main" style={style}>
          {children}
        </div>
      </div>
      <div
        className="layout-mask"
        onClick={() => {
          setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            overlayMenuActive: false,
            staticMenuMobileActive: false,
            menuHoverActive: false,
          }));
        }}
      />

      <Toast ref={toastRef} />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.shape({}),
};

Layout.defaultProps = {
  style: {},
};
export default Layout;
